import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';
import { TiTick, TiWarning } from 'react-icons/ti';
import creditcards from '../assets/creditcards.png';
import halopesa from '../assets/halopesa.png';
import ezypesa from '../assets/ezypesa.png';
import mpesa from '../assets/mpesa.png';
import tpesa from '../assets/tpesa.png';
import tigopesa from '../assets/tigopesa.png';
import airtelmoney from '../assets/airtelmoney.png';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ coinsToBuy, setCoinsToBuy ] = useState(10);
  const [ coinsPrice, setCoinsPrice ] = useState(0);
  const [ payWith, setPayWith ] = useState('mobile_money');
  const [ payPhone, setPayPhone ] = useState('');
  const [ loading, setLoading ] = useState(false);
  const [ finalMessage, setFinalMessage ] = useState(false);
  const [ finalError, setFinalError ] = useState(false);


  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await appContext.getMainParams().then((params) => {
      setCoinsPrice(params.coinToTsh * coinsToBuy)
      setReady(true);
    })

  }

  const handleCoinsToBuyChange = (coins) => {
    setCoinsToBuy(coins.trim());
  }

  const buyCoins = async () => {
    if(!isNaN(Number(coinsToBuy)) && Number(coinsToBuy) >= 10) {
      if(payWith.trim().length > 0) {
        //....
        let _checker = true;

        if(payWith === 'mobile_money') {
          if(payPhone.trim().length === 10) {
            //all is good
          } else {
            //bad
            _checker = false;
            appContext.tellError('Invalid phone number, write valid 10 digit phone number eg 07XXXXXXXX or 06XXXXXXXX')
          }
        }

        if(_checker) {
          setLoading(true);
          await callGameServerApi('init-coins-buy', { coinsToBuy, payPhone, payWith }).then((response) => {
            setLoading(false);
            if(response.status === 1) {
              if(payWith === 'credit_card') {
                setFinalMessage("You will be redirected to payment gateway on browser, please complete the payment for your coins");
                window.MobileInterface.openLink(response.payment_gateway_url);
              } else if(payWith === 'mobile_money') {
                setFinalMessage("USSD Notification was sent to your mobile phone number, please complete the payment for your coins")
              }
            } else {
              setFinalError(response.msg);
              appContext.tellError(response.msg);
            }
          })
        }
        //....
      } else {
        appContext.tellError('Please select payment method');
      }
      
      
    } else {
      appContext.tellError('Invalid coins amount, minimum is 10 coins')
    }
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    if(appContext.mainParams.coinToTsh && Number(coinsToBuy) > 0) {
      setCoinsPrice(appContext.mainParams.coinToTsh * coinsToBuy);
    } else {
      setCoinsPrice(0);
    }
  }, [ coinsToBuy ]);

  if(ready) {
    return (
      <>
        <TopBar title="Coins Shop"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container">
            <div className="row">

              {
                (!finalMessage && !finalError) ?
                <>
                <div className="col-md-12 col-sm-12" style={{ marginTop: "20px" }}>
                  <h1 className="font-light text-goldish">
                    1 Coin = {appContext.mainParams.coinToTsh} Tsh
                  </h1>
                </div>

                <div className="col-md-12 col-sm-12" style={{ marginTop: "20px" }}>
                  <div className="card text-start">
                    <div className="card-body">
                      <div className="form-group">
                        <label>Enter Coins Amount</label>
                        <input type="number" value={coinsToBuy} onChange={(e) => handleCoinsToBuyChange(e.target.value)} className="form-control" placeholder="Coins amount"/>
                        <small className="form-text">Minimum is 10 coins</small>
                      </div>

                      <div className="form-group">
                        <label>Coins</label>
                        <h1>{formatMoney(coinsToBuy)}</h1>
                      </div>

                      <div className="form-group">
                        <label>Total Price in Tsh</label>
                        <h1>{formatMoney(coinsPrice)}</h1>
                      </div>


                      {/*
                      <div className='form-group'>
                        
                        <label>Select Payment Method</label>
                        <select className='form-control' value={payWith} onChange={(e) => setPayWith(e.target.value)}>
                          <option value="mobile_money">Mobile Money - All Tanzania Networks</option>
                          <option value="credit_card">Credit/Debit Card - Visa, MasterCard, Express</option>
                        </select>
                      </div>
                      */}

                      {
                        (payWith === 'mobile_money') ?
                        <div className='form-group'>
                          <label>Your Phone Number</label>
                          <input placeholder='07XXXXXXXX or 06XXXXXXXX' maxLength={10} className='form-control' value={payPhone} onChange={(e) => setPayPhone(e.target.value.trim())}/>
                          <small className='form-text'>USSD Payment notification will be sent to this number</small>
                        </div> : ""
                      }

                      <div className="form-group">
                        <button 
                          onClick={buyCoins}
                          className="btn btn-block mNoMargin bg-goldish mSupportLoading"
                        >
                          BUY NOW
                        </button>
                        
                      </div>

                    </div>
                  </div>
                </div>
                </> : ""
                
              }

              {
                (finalMessage) ?
                <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px" }}>
                  <TiTick className='text-success' size={80}/>
                  <h5 className='font-light'>{finalMessage}</h5>
                  <hr/>
                  <button
                    className='btn bg-bluish'
                    onClick={() => {
                      setFinalError(false);
                      setFinalMessage(false);
                    }}
                  >
                    Buy Again
                  </button>
                </div> : ""
              }

              {
                (finalError) ?
                <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px" }}>
                  <TiWarning className='text-redish' size={80}/>
                  <h5 className='font-light'>{finalError}</h5>
                  <hr/>
                  <button
                    className='btn bg-bluish'
                    onClick={() => {
                      setFinalError(false);
                      setFinalMessage(false);
                    }}
                  >
                    Try Again
                  </button>
                </div> : ""
              }

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
